var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{on:{"click":_vm.ce}},[_vm._v("测试")]),_c('div',{on:{"click":_vm.ce2}},[_vm._v("测试2")])])
}
var staticRenderFns = []

export { render, staticRenderFns }